<template>
	<div>
		<div v-if="this.itemListDownload && this.itemListDownload.length > 0" style="border-bottom:1px solid var(--grey-5);">


			<h3 style="color:grey;margin-bottom:10px;">Ladda ned</h3>
			<div style="margin-bottom:10px;" v-for="item in this.itemListDownload" :key="item.itemId" class="flexcenter"
				:title="this.getTitle(item)">

				<div class="flexcenter link" style="width:40px;" @click="this.openUrl(item)">
					<Circle v-if="!this.isPDF(item)" fileName="w3_cloud_grey" color="--grey-2" size="35px" padding="15%" />
					<Circle v-if="this.isPDF(item)" fileName="w3_pdf_grey" color="--grey-2" size="35px" padding="25%" />
				</div>


				<div class="flexcenter" style="flex-direction: column;align-items: start;">
					<span class="link" @click="this.openUrl(item)">{{ item.desc?.toUpperCase() }}</span>
					<span v-if="this.debug">{{item.data }}</span>

				</div>


			</div>
		</div>
		<!-- youtube-filmer -->


		<div class="flexcenter"
			style="background:var(--grey-1);flex-wrap:wrap;gap:5px;justify-content: space-between;margin-top:20px;">
			<ItemYoutube v-for="(itemYoutube, index) in this.itemYoutubeList" :key="itemYoutube.itemId"
				:itemYoutube="itemYoutube" :size="this.size(index)" />




		</div>

	</div>

</template>
<script>
import ItemYoutube from './ItemYoutube.vue';


//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
//import { logMixin } from "@/mixins/logMixin.js";

export default {
	name: "ItemList",
	components: { ItemYoutube },
	mixins: [],
	props: {
		productId:Number
	},
	data() {
		return {
			addTestVideo: 0

		};
	},
	computed: {

		title() {
			return this.parentTitle + "\nItemList"
		},

		itemList() {
			return this.product?.details?.itemList
		},

		itemListDownload(){

			return this.product?.details?.itemList?.filter(item => item.type == "URL" && item.desc?.toLowerCase() != "youtube")

		},


		itemYoutubeList() {
			const list = this.product?.details?.itemList?.filter(item => item.type == "URL" && item.desc?.toLowerCase() == "youtube")

			if (this.addTestVideo > 0){
				for (let index = 0; index < this.addTestVideo; index++) {
					
					var item = {}
					item.itemId = parseInt(99999999 + index);
					if (index == 0){
						item.data = "https://www.youtube.com/embed/FmY7JdpD09A"
					}else{
						item.data = "https://www.youtube.com/embed/zWPFRk1MGuc"
					}
					
					
					item.desc = "youtube"
					item.type = "URL"
					item.itemsetId = 666;
					item.sort = 1
					item.isStartImage = false;

					list.push(item);
					
				}
			}

			return list;
		},

		product() {

			if (this.productId > 0) {
				return this.$store.state.productStore.data.productList[this.productId]
			}

			return null;

		},

		

	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });
		size(index) {

			if (this.itemYoutubeList?.length == 2) {
				return "size50";
			}

			if (index == 0){ // om det är 1 eller 3+ så visa den första stor
				return "";
			}

			if (this.itemYoutubeList?.length == 3 || this.itemYoutubeList?.length == 5){
				return "size50";
			}

			return "size33"; // om det är 4 eller fler filmer
		},

		getTitle(item){

			return "Länk: " + item.data

		},
		isPDF(item){

			return item?.desc?.toLowerCase()?.includes("pdf");

		},

		openUrl(item){
			window.open(item.data, '');
		}

	},
	created() {

	}
};
</script>

<style scoped></style>